import React, { useState } from "react"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

function CampaignCard({ campaign }) {
  const [isOpen, setIsOpen] = useState(false)
  const [index, setIndex] = useState(0)

  return (
    <div className="uk-flex uk-flex-column campaign-card">
      <div
        id="campaign-title"
        className="uk-text-italic uk-text-secondary uk-text-uppercase uk-text-bold uk-margin-small-bottom"
        style={{ fontSize: 14 }}
      >
        {campaign.title}
      </div>
      <div
        className="uk-inline uk-cover-container uk-width-1-1"
        onClick={() => setIsOpen(true)}
        style={{ height: 330 }}
      >
        <img
          src={campaign.images[0]}
          alt={campaign.title}
          className="uk-cover uk-margin-remove uk-width-1-1 uk-height-1-1"
        />
        <div className="uk-overlay-primary uk-position-cover"></div>
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={campaign.images[index]}
          nextSrc={campaign.images[(index + 1) % campaign.images.length]}
          clickOutsideToClose={true}
          enableZoom={false}
          imageCaption={
            <div className="image-caption uk-text-center">
              <p>{campaign.desc}</p>
            </div>
          }
          prevSrc={
            campaign.images[
              (index + campaign.images.length - 1) % campaign.images.length
            ]
          }
          onMovePrevRequest={() =>
            setIndex(
              (index + campaign.images.length - 1) % campaign.images.length
            )
          }
          onMoveNextRequest={() =>
            setIndex((index + 1) % campaign.images.length)
          }
          onCloseRequest={() => setIsOpen(false)}
        />
      )}
    </div>
  )
}

export default CampaignCard
